import React from 'react';
import usePageTranslation from '../../../shared/hooks/usePageTranslation';
import LegalPage from '../components/LegalPage';
import LegalSection from '../components/LegalSection';
import LegalContactBlock from '../components/LegalContactBlock';

const PolitiqueConfidentialite: React.FC = () => {
  const { t, loading } = usePageTranslation('public', 'PolitiqueConfidentialite');

  if (loading) return null;

  return (
    <LegalPage
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdate={t('lastUpdate')}
      lastUpdateDate={t('lastUpdateDate')}
    >
      <LegalSection number={1} title={t('introduction.title')}>
        <p className="text-lg text-gray-300">{t('introduction.description')}</p>
      </LegalSection>

      <LegalSection number={2} title={t('collection.title')}>
        <h3 className="text-xl font-semibold text-white mb-3">
          2.1 {t('collection.provided.title')}
        </h3>
        <ul className="space-y-2 mb-6">
          {t('collection.provided.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>

        <h3 className="text-xl font-semibold text-white mb-3">
          2.2 {t('collection.automatic.title')}
        </h3>
        <ul className="space-y-2">
          {t('collection.automatic.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={3} title={t('usage.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('usage.description')}</p>
        <ul className="space-y-2">
          {t('usage.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={4} title={t('sharing.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('sharing.description')}</p>
        <ul className="space-y-2">
          {t('sharing.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={5} title={t('security.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('security.description')}</p>
        <ul className="space-y-2">
          {t('security.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={6} title={t('retention.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('retention.description')}</p>
        <ul className="space-y-2 mb-4">
          {t('retention.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
        <p className="text-lg text-gray-300">{t('retention.note')}</p>
      </LegalSection>

      <LegalSection number={7} title={t('rights.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('rights.description')}</p>
        <ul className="space-y-2">
          {t('rights.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={8} title={t('cookies.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('cookies.description')}</p>
        <ul className="space-y-2 mb-4">
          {t('cookies.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
        <p className="text-lg text-gray-300">{t('cookies.note')}</p>
      </LegalSection>

      <LegalSection number={9} title={t('transfers.title')}>
        <p className="text-lg text-gray-300">{t('transfers.description')}</p>
      </LegalSection>

      <LegalSection number={10} title={t('minors.title')}>
        <p className="text-lg text-gray-300">{t('minors.description')}</p>
      </LegalSection>

      <LegalSection number={11} title={t('changes.title')}>
        <p className="text-lg text-gray-300">{t('changes.description')}</p>
      </LegalSection>

      <LegalSection number={12} title={t('contact.title')}>
        <LegalContactBlock
          description={t('contact.description')}
          discord={t('contact.discord')}
          discordAction={t('contact.discordAction')}
          email={t('contact.email')}
          owner={t('contact.owner')}
        />
      </LegalSection>
    </LegalPage>
  );
};

export default PolitiqueConfidentialite;
